import React, { useEffect, useRef } from 'react';
import { Container, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Box, Grid2, ListItemIcon, useTheme } from '@mui/material';
import WebBanner from '../../layouts/WebLayout/components/WebBanner/WebBanner';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Term from '../../assets/images/terms.svg';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../../layouts/WebLayout/SkipToMainContent/SkipToMainContentSlice';

const CopyRightPolicy = () => {
  const theme = useTheme();
  const dynamicTextColor = theme.palette.mode === "light" ? "#333333" : "#fff";
  const skipClicked=useSelector((state:any)=>
    {
       return state?.skip?.SkipButtonClicked
   });
const dispatch=useDispatch();
const sectionRef = useRef<HTMLElement | null>(null);
const handleScroll = () => {
   if (sectionRef.current) {
     sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
     dispatch(reset());
   }
 }
 useEffect(()=>{
   if(skipClicked){
   handleScroll() 
   } 
 },[skipClicked])

  const numberStyles = {
    backgroundColor: '#fff',
    color: '#1976d2',
    border: '2px solid #1976d2',
    fontWeight: 'bold',
  };
  return (
    <>
      <WebBanner
        title="Copyright Policy"
        subtitle=" "
        image={Term}
      />
      <Container maxWidth="xl">
        <Box sx={{padding:{ xs:"2rem 0",sm:"1rem 0"}}}>
          <Grid2 container sx={{
            justifyContent: "center"
          }}  ref={sectionRef as any}>
            <Grid2 size={12}  sx={{margin:{ xs:"2rem 0",sm:"3rem 0"}}}>
               <Typography variant="body1" sx={{fontSize:{xs:`calc(1em * var(--dynamic-font-size, 1))`,sm:`calc(1.25em * var(--dynamic-font-size, 1))`}, lineHeight: "40px", color: dynamicTextColor}}>
                             Material featured on this site may be reproduced free of charge in any format or media without requiring specific permission. This is subject to the material being reproduced accurately and not being used in a derogatory manner or in a misleading context. Where the material is being published or issued to others, the source must be prominently acknowledged. However, the permission to reproduce this material does not extend to any material on this site, which is identified as being the copyright of a third party. Authorisation to reproduce such material must be obtained from the copyright holders concerned.
                            </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </Container>
    </>
  );
};

export default CopyRightPolicy;
